import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'components/content';
import { IAppOnlyStore } from 'stores/AllStores';
import { action, computed } from 'mobx';
import classNames from 'classnames';
import { usaStatesList } from 'data/location';

// Styles
const s = require('./LeadRelationsModal.css');

// Props
interface ILeadRelationsModalProps extends IAppOnlyStore {
  show: boolean;
}

// Component
@inject('store')
@observer
export class LeadRelationsModal extends React.Component<
  ILeadRelationsModalProps,
  {}
> {
  @computed
  private get relations(): Array<{
    state: string;
    relations: Array<{
      name: string;
      type: string;
      address: string;
      phone: string | null;
      fax: string | null;
      contact: {
        name: string | null;
        email: string | null;
      };
    }>;
  }> {
    if (this.props.store.lead.openLeadDetails) {
      const statesKeys = [];
      return this.props.store.lead.openLeadDetails.relations.reduce(
        (states, relation) => {
          let index = statesKeys.indexOf(relation.state);
          if (index === -1) {
            index = statesKeys.length;
            statesKeys.push(relation.state);
            states.push({
              state: relation.state,
              relations: [],
            });
          }

          const address = [
            relation.address1,
            relation.address2,
            relation.city,
            relation.zipcode,
            relation.state,
          ].filter((addr) => addr !== null && addr !== '');

          states[index].relations.push({
            name: relation.name,
            type: relation.description,
            address: address.join(', '),
            phone:
              relation.phone && typeof relation.phone === 'number'
                ? relation.phone.toString()
                : relation.phone || null,
            // relation.extension && relation.phone
            //     ? `(${relation.extension}) ${relation.phone}`
            //     : relation.phone
            //     ? relation.phone.toString()
            //     : null,
            fax: null,
            // relation.extension && relation.fax
            //     ? `(${relation.extension}) ${relation.fax}`
            //     : relation.fax
            //     ? relation.fax.toString()
            //     : null,
            contact: {
              name: '',
              // (relation.contactTitle
              //     ? relation.contactTitle + ' '
              //     : '') + relation.contactName,
              email: '',
              // relation.contactEmail,
            },
          });

          return states;
        },
        []
      );
    }

    return [];
  }

  public render() {
    const {
      lead: { leadTitle, openLeadDetails },
    } = this.props.store;

    return (
      <Modal
        show={this.props.show}
        title={`${leadTitle} relations`}
        onModalClose={this.handleClosingModal}
      >
        {this.props.show && (
          <div className={s.container}>
            <div className={s.header}>
              {openLeadDetails && (
                <div className={s.summary}>
                  <h2>{openLeadDetails.dba || openLeadDetails.legalBusName}</h2>

                  {openLeadDetails.dba &&
                    openLeadDetails.legalBusName &&
                    openLeadDetails.dba !== openLeadDetails.legalBusName && (
                      <h3>{openLeadDetails.legalBusName}</h3>
                    )}
                </div>
              )}
            </div>

            <div className={s.items}>
              {this.relations.length <= 0 && (
                <div className={classNames(s.row, s.empty)}>
                  <p>No relations are available for this lead.</p>
                </div>
              )}

              {this.relations.map((region, regionIndex) => (
                <div key={region.state}>
                  <div className={classNames(s.row, s.stateRow)}>
                    <div>
                      <p>{usaStatesList[region.state] || region.state}</p>
                    </div>

                    <div>
                      <p>
                        {region.relations.length +
                          ' relation' +
                          (region.relations.length > 1 ? 's' : '')}
                      </p>
                    </div>
                  </div>

                  {region.relations.map((relation, relationIndex) => (
                    <div key={region.state + '-' + relationIndex}>
                      <div
                        className={classNames(s.row, s.subRow, s.relationRow)}
                      >
                        <div>
                          <p>{relation.name}</p>
                        </div>
                        <div>
                          <p>{relation.type}</p>
                        </div>
                      </div>

                      <div className={classNames(s.row, s.detailsRow)}>
                        <div>
                          {relation.address && <p>{relation.address}</p>}

                          {(relation.phone || relation.fax) && (
                            <p>
                              {relation.phone && <span>{'P. '}</span>}

                              {relation.phone && (
                                <strong>{relation.phone}</strong>
                              )}

                              {relation.fax && <span>{'F. '}</span>}

                              {relation.fax && <strong>{relation.fax}</strong>}

                              {relation.contact.email && <span>{'E. '}</span>}

                              {relation.contact.email && (
                                <strong>{relation.contact.email}</strong>
                              )}
                            </p>
                          )}

                          {relation.contact.name && (
                            <p>{relation.contact.name}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>
    );
  }

  @action
  private handleClosingModal = () => {
    this.props.store.lead.showRelationsOfOpenLead = false;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Relations/LeadRelationsModal.tsx